<script lang="ts" setup>
import type { IProps } from './UiCardBoxVariant1.types'

defineProps<IProps>()
</script>

<template>
  <article class="box-v1">
    <div class="box-v1__image">
      <img
        :src="box.image.url"
        :alt="box.image.alternative"
        :width="box.image.width ?? undefined"
        :height="box.image.height ?? undefined"
      >
    </div>

    <div
      class="box-v1__content"
    >
      <h3 class="box-v1__title">
        {{ box.title }}
      </h3>

      <div
        class="box-v1__text"
        v-html="box.text"
      />
    </div>
  </article>
</template>

<style lang="scss" scoped>
.box-v1 {
  width: 100%;
  padding:4rem;
  overflow: hidden;
  background-color: $white;
  border-radius: 1.6rem;

  &__image {
    width: 100%;
    margin-bottom: 3.2rem;
    overflow: hidden;

    img {
      width: auto;
    }
  }

  &__title {
    @include h9;
    margin-bottom: 3.2rem;

    @include atM {
      @include h8;
      margin-bottom: 2.4rem;
    }

    @include atXL {
      @include h8;
    }
  }

  &__text {
    @include h10;
  }
}
</style>
